<template>
    <div class="container"
        :class="{
            [customClass]: Boolean(customClass),
            'center': center
        }"
        :style="customStyle">
        <slot></slot>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    props: {
        customClass: {
            type: [Array, Object, String],
            required: false
        },
        customStyle: {
            type: [Object, String],
            required: false
        },
        center: {
            type: Boolean,
            default: false
        }
    }
});
</script>

<style lang="less" scoped>
.container {
    min-height: calc(100vh - 1rem);
    @media @pc {
        min-height: calc(100vh - 0.88rem);
    }
}
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
